import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=dc989d90&"
import script from "./Questionnaire.vue?vue&type=script&lang=ts&"
export * from "./Questionnaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports